import React, {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {loadNewPaymentsOptions} from './paymentActions';
import {
  paymentsDataSelector,
  paymentModuleOpenSelector,
  hotelReviewActions,
} from '@ibibo/hotels-review-reducer';
import {submitOTP, resendOTP} from '@ibibo/auth-apis';
import {userSelector} from '@ibibo/user-reducer';

const HotelsPaymentModule = () => {
  const dispatch = useDispatch();
  const {
    descBlockSuccess,
    paymentResponseSuccess,
    payMode,
    paymentType,
    hotelsPaymentLoading,
    bookingDetails,
    descBlockCdata,
    descBlockOfferKey,
    vendor,
  } = useSelector(paymentsDataSelector);
  const paymentModuleOpen = useSelector(paymentModuleOpenSelector);
  useEffect(() => {
    if (paymentResponseSuccess) initialisePayments();
    else loadNewPaymentsOptions();
  }, [paymentResponseSuccess]);

  const user = useSelector(userSelector);

  const initialisePayments = () => {
    if (paymentType === 1 || (paymentType === 2 && payMode === 3)) {
      if (!window.initPayment)
        loadNewPaymentsOptions({
          paySessionId: bookingDetails.payusession,
          containerId: 'gi_paymentframe',
          callback: backFromPayments,
        });
    }

    if (paymentType === 2 && payMode !== 3) {
      // pay at hotel flow where otp can be skiped
      if (bookingDetails.skip_otp_screen) {
        const payLaterForm = document.querySelector('#finalsubmitToHotelBookingForm');
        payLaterForm.submit();
      }
      // else otp box will open (handled in render automatically)
      // on submit of otp form will get submitted
    }
  };

  const submitotp = async () => {
    const payLaterForm = document.querySelector('#finalsubmitToHotelBookingForm');
    const mobile = payLaterForm.mobile.value;
    const otp = document.querySelector('#otpPopup #plsmsvercode').value;
    const success = await submitOTP(otp, mobile);
    payLaterForm.plsmsvercode.value = otp;
    if (success) {
      payLaterForm.submit();
    } else {
      document.querySelector('#invalidOTP').classList.remove('dn');
      // something went wrong
    }
  };

  const resendotp = async () => {
    const payLaterForm = document.querySelector('#finalsubmitToHotelBookingForm');
    const mobile = payLaterForm.mobile.value;
    const success = await resendOTP(mobile);
    if (success) {
      document.querySelector('#resentOTP').classList.remove('dn');
    } else {
      document.querySelector('#failedOTP').classList.remove('dn');
    }
  };

  const backFromPayments = () => {
    dispatch(hotelReviewActions.resetPaymentsData());
  };

  if (!paymentModuleOpen) return null;

  if ((paymentType === 1 || (paymentType === 2 && payMode === 3)) && window.initPayment) {
    window.initPayment({
      // paySessionId: bookingDetails.payusession,
      paySessionId: bookingDetails.pay_session_id,
      containerId: 'gi_paymentframe',
      callback: backFromPayments,
    });
    // const {offer_key, isLoggedin = false, vendor} = this.props;

    const isLoggedin = user.isLoggedin;
    const paymentMeta = {
      native_pay_amnt: descBlockCdata.personalized_keys
        ? descBlockCdata.personalized_keys.np_wt
        : descBlockCdata.aftrpromototal,
      vested_gocash: descBlockCdata.vested_gocash || 0,
      non_vested_gocash: descBlockCdata.non_vested_gocash || 0,
      credits_amount: descBlockCdata.max_gocash || 0,
    };

    const payableAmount = paymentMeta.native_pay_amnt
      ? paymentMeta.native_pay_amnt
      : descBlockCdata.aftrpromototal;
    const isPAH = descBlockCdata.is_pah;
    const payPG = descBlockCdata.is_pah ? 'adyen' : 'payu';

    return (
      <div>
        <div id="gi_paymentframe" className={'paymentOption fl width100 posRel padT10'}>
          loading...
        </div>
        <input type="hidden" name="go_pay_vertical" value="hotels" id="go_pay_vertical"></input>
        <input type="hidden" name="offer_key" value={descBlockOfferKey} id="offer_key"></input>
        <input type="hidden" name="go_pg" value={payPG} id="go_pay_pg"></input>
        <input
          type="hidden"
          name="native_pay_amnt"
          id="native_pay_amnt"
          value={payableAmount}
        ></input>
        <input
          type="hidden"
          name="hiddenudf2"
          value={isLoggedin ? 'false' : 'true'}
          id="hiddenudf2"
        ></input>
        <input type="hidden" name="pay_at_hotel" value={isPAH} id="pay_at_hotel"></input>
        <input type="hidden" name="hotel_vendor" value={vendor} id="hotel_vendor"></input>
      </div>
    );
  }

  if (paymentType === 2 && payMode !== 3) {
    const otpEntered = '';
    return (
      <div>
        {/* <Header header="Payment" buildingIcon={false} /> */}
        <div id="gi_paymentframe" className={'paymentOption fl width100 posRel padT10'}></div>
        <form
          id="finalsubmitToHotelBookingForm"
          name="finalsubmitToHotelBookingForm"
          action={bookingDetails.surl}
          method="POST"
        >
          <input type="hidden" name="email" value={bookingDetails.email || ''} />
          <input type="hidden" name="firstname" value={bookingDetails.firstname || ''} />
          <input type="hidden" name="amount" value={bookingDetails.amount || ''} />
          <input type="hidden" name="transactionid" value={bookingDetails.transactionid || ''} />
          <input
            type="hidden"
            name="txnid"
            value={bookingDetails.txnid || bookingDetails.transactionid || ''}
          />
          <input type="hidden" name="hash" value={bookingDetails.hash || ''} />
          <input type="hidden" name="pay_mode" value={bookingDetails.pay_mode || ''} />
          <input type="hidden" name="creditsamount1" value={bookingDetails.creditsamount1 || ''} />
          <input type="hidden" name="crdid" value={bookingDetails.crdid || ''} />
          <input type="hidden" name="gocashcheck" value={bookingDetails.gocashcheck || ''} />
          <input type="hidden" name="payu_amount" value={bookingDetails.payu_amount || ''} />
          <input type="hidden" name="mihpayid" value={bookingDetails.mihpayid || ''} />
          <input type="hidden" name="status" value={bookingDetails.status || ''} />
          <input type="hidden" name="mobile" value={bookingDetails.mobile || ''} />
          <input type="hidden" name="plsmsvercode" value={otpEntered} id="form_plsmsvercode" />
          <input type="submit" className="dn" />
        </form>
        {(!bookingDetails.skip_otp_screen && bookingDetails.otpinfo === 'success' && (
          <div className="popModal zoom mediumSmall popShow" id="otpPopup">
            <div className="popContent">
              <a
                href="javascript:void(0)"
                className="fr icon-close ico12 popClose"
                onClick={() => {}}
              ></a>
              <div className="popBody ">
                <input
                  type="text"
                  className="form-control col-xs-6"
                  id="plsmsvercode"
                  name="plsmsvercode"
                />
                <input
                  type="button"
                  value="Reserve Booking"
                  className="button blue marginL10 marginT2"
                  id="final-submit-hotel-booking"
                  onClick={submitotp}
                />
                <span className="fl green">
                  <span className="fl padB5 lh1-2 width100 padT15">
                    Please enter verification code sent to your mobile.
                  </span>
                  <a href="javascript:void(0);" className="fl padT10" onClick={resendotp}>
                    {' '}
                    Send me code again
                  </a>
                  <img
                    src="/images/v2/common/ajax-loader.gif"
                    id="ajax_loader"
                    className="dn"
                  ></img>
                </span>
                <span id="invalidOTP" className="dn">
                  SMS authentication failed
                </span>
                <span id="resentOTP" className="dn">
                  SMS resent to your mobile
                </span>
                <span id="failedOTP" className="dn">
                  SMS not sent
                </span>
              </div>
            </div>
          </div>
        )) ||
          null}
      </div>
    );
  }

  return null;
};

export default HotelsPaymentModule;
